module.exports = __webpack_public_path__ + "img/group2Img.32affc26.png";